<app-message-box *ngIf="resentSuccess" level="success">The email was successfully resent.</app-message-box>
<div class="suif-h3">
    Almost done! Check your email to finish recovering your account.
</div>
<div class="suif-body-copy">
    You should receive an email momentarily to <strong>{{ emailAddress }}</strong>. If you don't see it, check your spam
    folder, or <button type="button" class="button-link" (click)="resendEmail()">send another email now</button>.
    If your email is incorrect, please
    <button type="button" class="button-link" (click)="sendToNewEmail()">start over with a new email address</button>.
</div>